import { getRequest, postRequest, putRequest } from './api-requests';
import apiConfig from '../../../api-config';

export const Companies = Object.freeze({
    list: (data = {}) => {
        let getString = '';
        if (data.sortBy !== undefined) {
            getString += `?sort_by=${data.sortBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`;
        }
        return getRequest(`${apiConfig.base_url}/web/company${getString}`);
    },

    listReduced: () => getRequest(`${apiConfig.base_url}/web/company/list`),

    pharmacies: id => getRequest(`${apiConfig.base_url}/web/company/${id}/pharmacies`),

    single: id => getRequest(`${apiConfig.base_url}/web/company/${id}`),

    add: details => postRequest(`${apiConfig.base_url}/web/company`, details),

    edit: (id, details) => putRequest(`${apiConfig.base_url}/web/company/${id}`, details),

    statistics: id => {
        if (id !== undefined) {
            return getRequest(`${apiConfig.base_url}/web/company/${id}/statistic`);
        } else {
            return null;
        }
    },

    whitoutOwner: () => getRequest(`${apiConfig.base_url}/web/company/without_owner`),

    whitoutManager: (id) => getRequest(`${apiConfig.base_url}/web/company/${id}/pharmacy/without_manager`)
});



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-companies.js